import { CameraSource, CameraStreamWithDeviceId } from '@/types/camera'
import {
  EventDestination,
  EventEndpoint,
  MilestoneEventEndpoint
} from '@/types/deployment'

const buildMilestoneEndpoint = (
  endpoint: MilestoneEventEndpoint,
  cameraStream: CameraStreamWithDeviceId
): MilestoneEventEndpoint => ({
  service: EventDestination.Milestone,
  endpoint: endpoint.endpoint,
  attributes: {
    milestone_camera_id: cameraStream.attributes?.milestone_camera_id || '',
    milestone_stream_ids: cameraStream.attributes?.milestone_stream_ids || []
  }
})

const buildEndpoint = (
  eventEndpoint: EventEndpoint,
  cameraStream: CameraStreamWithDeviceId
): EventEndpoint => {
  switch (eventEndpoint.service) {
    case EventDestination.Visionplatform:
      return { service: EventDestination.Visionplatform }
    case EventDestination.CustomApi:
    case EventDestination.Mqtt:
      return eventEndpoint
    case EventDestination.Milestone:
      return buildMilestoneEndpoint(eventEndpoint, cameraStream)
  }
}

export const buildEventEndpoints = (
  eventEndponts: EventEndpoint[],
  cameraStream: CameraStreamWithDeviceId
): EventEndpoint[] => {
  return eventEndponts
    .filter((eventEndpoint) => {
      // Do not include Milestone endpoints if the camera source is not Milestone
      if (
        eventEndpoint.service === EventDestination.Milestone &&
        cameraStream.source !== CameraSource.Milestone
      ) {
        return false
      }
      return true
    })
    .map((eventEndpoint) => buildEndpoint(eventEndpoint, cameraStream))
}
